import { ParsedUrlQuery } from "querystring";
import { FacetParameterInput, getActiveFilters, parseParams } from "./querystring";

export type ListType = 'gallery' | 'extended'

const ACCEPTED_SORTBY_VALUES = ['relevance', 'asc', 'desc', 'alphabetical', 'sales', 'review_score']

const defaultQueryState = {
  activeFilters: [] as FacetParameterInput[],
  categorypath: '',
  page: 1,
  pagesize: 20,
  searchwithin: '',
  sortby: undefined,
  view: 'extended' as ListType,
  sp: '',
  tab: '',
}

const getSortBy = (paramValue: string) => {
  if (ACCEPTED_SORTBY_VALUES.includes(paramValue)) {
    return paramValue
  }
}

const getListType = (paramValue: string): ListType => {
  switch (paramValue) {
    case 'gallery':
      return paramValue

    case 'extended':
    default:
      return 'extended'
  }
}

export const buildQueryState = (params: ParsedUrlQuery) => {
  const parsedParams = parseParams(params)

  const activeFilters = getActiveFilters(parsedParams)
  const page = Number(parsedParams.page) || 1
  let pagesize = Number(parsedParams.pagesize) || 20
  if (![20, 50, 100].includes(pagesize)) {
    pagesize = 20
  }
  const sortby = getSortBy(parsedParams.sortBy || parsedParams.sortby)
  const view = getListType(parsedParams.view)

  return {
    ...defaultQueryState,
    ...parsedParams,
    activeFilters,
    page,
    pagesize,
    sortby,
    view,
  }
}
